// Registry of editable content per public page (CMS admin editor).
// `key` = dot-path into translations; `def` for images = current hardcoded default.

export const IMG_DEFAULTS = {
  "home.hero": "https://images.unsplash.com/photo-1498623116890-37e912163d5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  "club.header": "https://images.unsplash.com/photo-1503634192480-e77a6436f075?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  "voile.header": "https://images.unsplash.com/photo-1561728130-afd430af0493?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  "voile.school": "https://images.unsplash.com/photo-1503634192480-e77a6436f075?w=1200",
  "voile.seatrips": "https://images.unsplash.com/photo-1498623116890-37e912163d5d?w=1200",
  "motor.header": "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  "motor.security": "https://images.unsplash.com/photo-1603625094339-c6d5f80e9cfa?w=1200",
  "stages.header": "https://images.unsplash.com/photo-1501771924607-209f42a6e7e4?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
  "regattas.header": "https://images.unsplash.com/photo-1498623116890-37e912163d5d?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
};

export function getPath(obj, path) {
  return path.split(".").reduce((acc, k) => (acc == null ? undefined : acc[k]), obj);
}

export const CONTENT_PAGES = {
  home: {
    label: "Accueil",
    texts: [
      { key: "home.eyebrow", label: "Sur-titre héro" },
      { key: "home.heroTitle", label: "Titre héro", type: "textarea" },
      { key: "home.heroSub", label: "Sous-titre héro", type: "textarea" },
      { key: "home.ctaPrimary", label: "Bouton 1 — libellé" },
      { key: "home.ctaPrimaryLink", label: "Bouton 1 — lien" },
      { key: "home.ctaSecondary", label: "Bouton 2 — libellé" },
      { key: "home.ctaSecondaryLink", label: "Bouton 2 — lien" },
      { key: "home.ctaTertiary", label: "Bouton 3 — libellé" },
      { key: "home.ctaTertiaryLink", label: "Bouton 3 — lien" },
      { key: "home.newsTitle", label: "Actualités — titre" },
      { key: "home.newsSub", label: "Actualités — sous-titre" },
      { key: "home.weatherTitle", label: "Météo — titre" },
      { key: "home.weatherText", label: "Météo — texte", type: "textarea" },
    ],
    lists: [
      { key: "home.quickLinks", label: "Liens rapides", fields: [{ name: "label", label: "Libellé" }, { name: "path", label: "Lien" }] },
      { key: "home.pillars", label: "Piliers", fields: [{ name: "title", label: "Titre" }, { name: "text", label: "Texte", type: "textarea" }] },
      { key: "home.weatherLinks", label: "Liens météo", fields: [{ name: "label", label: "Libellé" }, { name: "url", label: "URL" }] },
    ],
    images: [{ key: "hero", label: "Image héro" }],
    sections: [
      { id: "quicklinks", label: "Liens rapides" }, { id: "news", label: "Actualités" },
      { id: "pillars", label: "Piliers" }, { id: "agenda", label: "Agenda" }, { id: "weather", label: "Météo & Meuse" },
    ],
  },
  club: {
    label: "Le Club",
    texts: [
      { key: "club.eyebrow", label: "Sur-titre" },
      { key: "club.title", label: "Titre" },
      { key: "club.lead", label: "Introduction", type: "textarea" },
      { key: "club.historyTitle", label: "Histoire — titre" },
      { key: "club.historyText", label: "Histoire — texte", type: "textarea" },
      { key: "club.locationTitle", label: "Situation — titre" },
      { key: "club.locationText", label: "Situation — texte", type: "textarea" },
      { key: "club.boardTitle", label: "CA — titre" },
      { key: "club.boardSub", label: "CA — sous-titre" },
      { key: "club.duesTitle", label: "Cotisations — titre" },
      { key: "club.duesSub", label: "Cotisations — sous-titre" },
      { key: "club.admissionTitle", label: "Admission — titre" },
      { key: "club.admissionSub", label: "Admission — texte", type: "textarea" },
      { key: "club.welcomeTitle", label: "Bloc bienvenue — titre" },
      { key: "club.welcomeText", label: "Bloc bienvenue — texte", type: "textarea" },
      { key: "club.privacyTitle", label: "RGPD — titre" },
      { key: "club.privacyText", label: "RGPD — texte", type: "textarea" },
    ],
    lists: [],
    images: [{ key: "header", label: "Image d'en-tête" }],
    sections: [
      { id: "history", label: "Histoire & Situation" }, { id: "board", label: "Conseil d'administration" },
      { id: "dues", label: "Cotisations" }, { id: "admission", label: "Demande d'admission" }, { id: "privacy", label: "Vie privée / RGPD" },
    ],
  },
  voile: {
    label: "Voile",
    texts: [
      { key: "voile.eyebrow", label: "Sur-titre" },
      { key: "voile.title", label: "Titre" },
      { key: "voile.lead", label: "Introduction", type: "textarea" },
      { key: "voile.schoolTitle", label: "École — titre" },
      { key: "voile.schoolText", label: "École — texte", type: "textarea" },
      { key: "voile.boatsTitle", label: "Bateaux — titre" },
      { key: "voile.brevetsTitle", label: "Brevets — titre" },
      { key: "voile.seaTripsTitle", label: "Sorties en mer — titre" },
      { key: "voile.seaTripsText", label: "Sorties en mer — texte", type: "textarea" },
    ],
    lists: [
      { key: "voile.brevets", label: "Brevets (liste)", simple: true },
    ],
    images: [
      { key: "header", label: "Image d'en-tête" },
      { key: "school", label: "Image école" },
      { key: "seatrips", label: "Image sorties en mer" },
    ],
    sections: [
      { id: "school", label: "École" }, { id: "boats", label: "Bateaux" },
      { id: "brevets", label: "Brevets" }, { id: "seatrips", label: "Sorties en mer" },
    ],
  },
  motor: {
    label: "Moteur",
    texts: [
      { key: "motor.eyebrow", label: "Sur-titre" },
      { key: "motor.title", label: "Titre" },
      { key: "motor.lead", label: "Introduction", type: "textarea" },
      { key: "motor.securityTitle", label: "Sécurité — titre" },
      { key: "motor.securityText", label: "Sécurité — texte", type: "textarea" },
      { key: "motor.boatsTitle", label: "Bateaux — titre" },
      { key: "motor.brevetsTitle", label: "Brevets — titre" },
    ],
    lists: [
      { key: "motor.boats", label: "Bateaux de sécurité", fields: [{ name: "tag", label: "Étiquette" }, { name: "name", label: "Nom" }, { name: "text", label: "Texte", type: "textarea" }, { name: "image", label: "Image", type: "image" }] },
      { key: "motor.brevetsList", label: "Brevets", fields: [{ name: "name", label: "Nom" }, { name: "text", label: "Texte", type: "textarea" }] },
    ],
    images: [
      { key: "header", label: "Image d'en-tête" },
      { key: "security", label: "Image sécurité" },
    ],
    sections: [
      { id: "security", label: "Team Sécurité" }, { id: "boats", label: "Bateaux de sécurité" }, { id: "brevets", label: "Brevets" },
    ],
  },
  stages: {
    label: "Stages",
    texts: [
      { key: "stages.eyebrow", label: "Sur-titre" },
      { key: "stages.title", label: "Titre" },
      { key: "stages.lead", label: "Introduction", type: "textarea" },
      { key: "stages.register", label: "Bouton s'inscrire" },
      { key: "stages.lastPlaces", label: "Badge « Dernières places »" },
    ],
    lists: [],
    images: [{ key: "header", label: "Image d'en-tête" }],
    sections: [],
    options: [
      { key: "low_places_threshold", label: "Seuil « Dernières places » — le badge s'affiche quand il reste ce nombre de places ou moins", type: "number", def: 3 },
    ],
  },
  regattas: {
    label: "Régates",
    texts: [
      { key: "regattas.eyebrow", label: "Sur-titre" },
      { key: "regattas.title", label: "Titre" },
      { key: "regattas.lead", label: "Introduction", type: "textarea" },
    ],
    lists: [],
    images: [{ key: "header", label: "Image d'en-tête" }],
    sections: [],
  },
  agenda: {
    label: "Agenda",
    texts: [
      { key: "agenda.eyebrow", label: "Sur-titre" },
      { key: "agenda.title", label: "Titre" },
      { key: "agenda.lead", label: "Introduction", type: "textarea" },
    ],
    lists: [],
    images: [],
    sections: [],
  },
  gallery: {
    label: "Galerie",
    texts: [
      { key: "gallery.eyebrow", label: "Sur-titre" },
      { key: "gallery.title", label: "Titre" },
      { key: "gallery.lead", label: "Introduction", type: "textarea" },
    ],
    lists: [],
    images: [],
    sections: [],
  },
  shop: {
    label: "Boutique",
    texts: [
      { key: "shop.eyebrow", label: "Sur-titre" },
      { key: "shop.title", label: "Titre" },
      { key: "shop.lead", label: "Introduction", type: "textarea" },
    ],
    lists: [],
    images: [],
    sections: [],
  },
  contact: {
    label: "Contact",
    texts: [
      { key: "contact.eyebrow", label: "Sur-titre" },
      { key: "contact.title", label: "Titre" },
      { key: "contact.lead", label: "Introduction", type: "textarea" },
      { key: "contact.hoursValue", label: "Horaires d'ouverture" },
      { key: "contact.addressValue", label: "Adresse" },
      { key: "contact.bankSub", label: "Banque — sous-titre" },
      { key: "contact.bankHolderValue", label: "Banque — titulaire" },
      { key: "contact.communicationValue", label: "Banque — communication" },
      { key: "contact.faqTitle", label: "FAQ — titre" },
    ],
    lists: [],
    images: [],
    sections: [
      { id: "info", label: "Coordonnées" }, { id: "map", label: "Carte" },
      { id: "social", label: "Réseaux sociaux" }, { id: "bank", label: "Coordonnées bancaires" }, { id: "faq", label: "FAQ" },
    ],
  },
};
